<template>
  <div class="share-lang-list">
    <div class="share-lang-list__label">
      选择要分享的字幕语种：
    </div>
    <el-checkbox-group
      v-if="false"
      ref="radioGroup"
      :value="currentId"
      class="share-lang-list__list"
      size="small"
      @change="chooseNewShareVideoTTsFun"
    >
      <div
        v-for="item in ttsList"
        :key="item.id"
        :class="[ttsList.indexOf(item.id)>-1?'share-lang-list__item chooseCheckItem':'share-lang-list__item']"
        @click.prevent="onClick(item)"
      >
        <el-checkbox-button
          :label="item.id"
        >
          <img
            :src="item.icon"
            alt=""
          >
          <span>{{ item.languageName }}</span>
        </el-checkbox-button>
      </div>
    </el-checkbox-group>
    <el-radio-group
      ref="radioGroup"
      v-model="radioId"
      class="share-lang-list__list"
      @change="onChange"
    >
      <div
        v-for="item in ttsList"
        :key="item.id"
        :class="[radioId === item.id ? 'share-lang-list__item chooseCheckItem':'share-lang-list__item']"
      >
        <el-radio-button
          :label="item.id"
        >
          <img
            :src="item.icon"
            alt=""
          >
          <span>{{ item.languageName }}</span>
        </el-radio-button>
      </div>
    </el-radio-group>
  </div>
</template>
<script>
export default {
  props: {
    ttsList: {
      type: Array,
      default: () => []
    },
    currentId: {
      type: Array,
      default: () => []
    },
    // videoList: {
    //   type: Array,
    //   default: () => []
    // },
    params: {
      type: Array,
      default: () => []

    }
  },
  data () {
    return {
      radioId: ''
    }
  },
  computed: {

  },
  watch: {
    currentId (val) {
      if (val) {
        this.radioId = this.currentId[0]
      }
    }
  },
  mounted () {
    this.radioId = this.currentId[0]
  },
  methods: {
    onChange (val) {
      console.log('onChange', val)
      this.$emit('update:currentId', [val])
    },
    chooseNewShareVideoTTsFun (val) {
      console.log('chooseNewShareVideoTTsFun', val)
    },
    async getFishEnv () {
      const res = await my_http_ajax('/api/user/get-fish-tenant', 'GET', {}, self)
      if (res.status === 1 && res.data) {
        const codeRes = await my_http_ajax(
          res.data.api_url + '/v2/tenant/passport/auth-code',
          'post',
          { account_id: res.data.tenant_account_id, tenant_id: res.data.tenant_id },
          self,
          false,
          { appKey: res.data.key }
        )
        if (codeRes.code === 0) {
          return {
            ...res.data,
            auth_code: codeRes.data
          }
        }
      }
      return null
    },
    async onClick (item) {
      console.log('onClick', item)
      console.log('params', this.params)
      // ttsVideo
      const videoList = this.params[0].ttsVideo
      const video = videoList.find(i => i.id === item.id) || videoList[0]
      console.log('video', video)
      return
      const env = await this.getFishEnv()
      if (env && video) {
        const url = `${env.domain}/social-media/release/video-sharing?auth_code=${env.auth_code}&client_id=${env.tenant_account_id}`
        // const url = `http://social.dweyes.cn/social-media/release/video-sharing?auth_code=${env.auth_code}&client_id=${env.tenant_account_id}`
        const videoUrl = encodeURIComponent(video.wurl || video.url)
        const thumbnail = encodeURIComponent(video.thumbnail)
        console.log(`${url}&videourl=${videoUrl}&thumbnail=${thumbnail}`)
        const a = document.createElement('a')
        a.setAttribute('href', `${url}&videourl=${videoUrl}&thumbnail=${thumbnail}`)
        a.setAttribute('target', '_blank')
        a.click()
        this.$parent.closeDialog()
      } else {
        this.$message({
          message: '分享失败',
          type: 'error',
          duration: '2000'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.share-lang-list {
  min-height: 100px;

}
:deep .el-radio-button  .el-radio-button__inner{
  padding: 9px 15px;
  font-size: 12px;
  height: 40px;
}
</style>
<style lang="scss">
.share-lang-list .share-lang-list__item .el-radio-button  .el-radio-button__inner{
  padding: 9px 15px;
  font-size: 12px;
  height: 40px;
}
</style>
